"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabNavigation = exports.StyledTabItem = exports.StyledTabContainer = exports.StyledIcon = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _utils = require("../lib/utils");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var variants = {
  vertical: (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    flex-direction: row;\n  "]))),
  horizontal: (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    flex-direction: column;\n  "])))
};
var type = {
  "default": (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n  "])), function (props) {
    return variants[props.variant];
  }),
  grouped: (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n    flex-direction: column;\n  "])))
};
var variantNav = {
  vertical: (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n    flex-direction: column;\n  "]))),
  horizontal: (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n    white-space: nowrap;\n    overflow-x: auto;\n    padding-bottom: 2px;\n  "])))
};
var typeNav = {
  "default": (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n  "])), function (props) {
    return variantNav[props.variant];
  }),
  grouped: (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    padding: 0px;\n  "])))
};
var variantItem = {
  vertical: (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n    padding: 8px 30px 8px 0px;\n    border-right: 2px solid ", ";\n    &::after {\n      right: -2px;\n      width: 4px;\n      top: 0;\n      bottom: 0;\n    }\n  "])), function (props) {
    return (0, _utils.getPalette)(props.color, 'c01')(props);
  }),
  horizontal: (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n    padding: 8px 24px 8px 8px;\n    border-bottom: 2px solid\n      ", ";\n    &:last-child {\n      flex: 1;\n      pointer-events: none;\n    }\n    &::after {\n      bottom: -2px;\n      height: 2px;\n      left: 0;\n      right: 0;\n    }\n\n    ", "\n  "])), function (props) {
    return (0, _utils.getPalette)(props.borderColor || props.color, props.borderShade || 'c00')(props);
  }, function (props) {
    return (0, _utils.isRTL)(props) ? "&:last-child {\n      padding-right: 0px;\n    }" : "&:first-child {\n      padding-left: 4px;\n    }";
  })
};
var typeItem = {
  "default": (0, _styledComponents.css)(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n    color: ", ";\n    &:hover {\n      color: ", ";\n\n      }\n      &::after {\n        background-color: ", ";\n      }\n    }\n    ", "\n    ", "\n  "])), function (props) {
    return variantItem[props.variant];
  }, function (props) {
    return (0, _utils.getPalette)(props.textColor || 'text', props.textShade || 'c01')(props);
  }, function (props) {
    return (0, _utils.getPalette)(props.textHoverColor || 'text', props.textHoverShade || 'c04')(props);
  }, function (props) {
    return (0, _utils.getPalette)(props.backgroundHoverColor || props.color, props.backgroundHoverShade || 'c00')(props);
  }, function (props) {
    return props.active && "\n    &::after {\n      background-color: ".concat((0, _utils.getPalette)(props.backgroundColor || props.color, props.backgroundShade || 'c03')(props), " !important;\n    }\n  ");
  }, function (props) {
    return props.active && "\n    color: ".concat((0, _utils.getPalette)(props.textActiveColor || props.color, props.textActiveShade || 'c02')(props), " !important;\n  ");
  }),
  grouped: (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 8px 16px;\n    margin-right: 8px;\n    background: ", ";\n    color: ", ";\n    border-radius: 20px;\n    border: 1px solid transparent;\n    .t-text {\n      position: relative;\n      top: 1px;\n    }\n    ", "\n    ", "\n  ", "\n", "\n  "])), function (props) {
    return (0, _utils.getPalette)('light', 'c200')(props);
  }, function (props) {
    return (0, _utils.getPalette)('text', 'c02')(props);
  }, function (props) {
    return props.active && "\n    background-color: ".concat((0, _utils.getPalette)(props.color, 'c05')(props), ";\n    color: ").concat((0, _utils.getPalette)('primary', 'c02')(props), ";\n  ");
  }, function (props) {
    return props.hasIconLeft && props.hasTitle && "\n  padding: 8px 16px";
  }, function (props) {
    return props.hasIconRight && props.hasTitle && "\npadding: 8px 16px;\nmargin-right: 8px;";
  }, function (props) {
    return (props.hasIconRight || props.hasIconLeft) && !props.hasTitle && "\npadding-right: 16px;\npadding-left: 16px;\n";
  })
};

var StyledTabContainer = _styledComponents["default"].div(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  ", "\n  ", "\n\n  .eui-tab-content {\n    ", "\n  }\n"])), function (props) {
  return type[props.type];
}, function (props) {
  return ".eui-tab-nav {\n    min-width: ".concat(props.minWidth, ";\n  }");
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
});

exports.StyledTabContainer = StyledTabContainer;

var TabNavigation = _styledComponents["default"].div(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  ", "\n  ", "\n"])), function (props) {
  return typeNav[props.type];
}, function (props) {
  return (0, _utils.isRTL)(props) && "justify-content: flex-end;";
});

exports.TabNavigation = TabNavigation;

var StyledTabItem = _styledComponents["default"].div(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  cursor: pointer;\n  position: relative;\n\n  &::after {\n    content: '';\n    display: block;\n    position: absolute;\n  }\n\n  ", "\n\n  ", "\n"])), function (props) {
  return (0, _utils.getTypography)('label')(props);
}, function (props) {
  return typeItem[props.type];
}, function (props) {
  return props.disabled && "\n    cursor: not-allowed;\n  ";
});

exports.StyledTabItem = StyledTabItem;

var StyledIcon = _styledComponents["default"].span(_templateObject16 || (_templateObject16 = (0, _taggedTemplateLiteral2["default"])(["\n  height: ", ";\n  svg {\n    path {\n      fill: ", ";\n    }\n  }\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  return props.height;
}, function (props) {
  return (0, _utils.getPalette)('text', 'c04')(props);
}, function (props) {
  return props.hasIconLeft && props.hasTitle && "\n    padding-right: 4px;\n    ";
}, function (props) {
  return props.hasIconRight && props.hasTitle && "\n    padding-left: 4px;\n  ";
}, function (props) {
  return (props.hasIconLeft || props.hasIconRight) && props.active && "\n  svg {\n    path {\n      fill:  ".concat((0, _utils.getPalette)(props.textColor || 'primary', props.activeTextShade || 'c02')(props), "\n    }\n  }\n\n  ");
});

exports.StyledIcon = StyledIcon;